<template>
    <div class="main">

        <div class="resume_info_box">
            <div class="card_title">
                员工信息
            </div>
            <div class="resume_info_field">
                <div class="resume_field">
                    姓名：
                </div>
                <div class="resume_value">
                    {{ resume_info.name }}
                </div>
            </div>
            <div class="resume_info_field">
                <div class="resume_field">
                    身份证号：
                </div>
                <div class="resume_value">
                    {{ resume_info.idcard }}
                </div>
            </div>
            <div class="resume_info_field">
                <div class="resume_field">
                    手机号码：
                </div>
                <div class="resume_value">
                    {{ resume_info.phone }}
                </div>
            </div>
            <div class="resume_info_field">
                <div class="resume_field">
                    实名状态：
                </div>
                <div class="resume_value">
                    <span v-if="resume_info.is_certification == 1">已实名认证
                        <Icon type="ios-checkmark-circle" color="#19be6b" />
                    </span>
                    <span v-else class="weishiming">未实名认证
                        <Icon type="ios-close-circle" color="#ed4014" />
                    </span>

                </div>
            </div>
        </div>

        <div class="resume_info_box">
            <div class="card_title">
                身份证照片
            </div>
            <div class="resume_info_field">
                <div class="resume_field">
                    人像面：
                </div>
                <div class="resume_value">
                    <img @click="view_idcard_img(resume_info.idcard_img_a_url)"
                        v-if="resume_info.idcard_img_a_url != ''" class="idcard_img" :src="resume_info.idcard_img_a_url"
                        alt="">
                    <div class="idcard_img" v-else>
                        未完善
                    </div>
                </div>
            </div>
            <div class="resume_info_field">
                <div class="resume_field">
                    国徽面：
                </div>
                <div class="resume_value">
                    <img @click="view_idcard_img(resume_info.idcard_img_b_url)"
                        v-if="resume_info.idcard_img_b_url != ''" class="idcard_img" :src="resume_info.idcard_img_b_url"
                        alt="">
                    <div class="idcard_img" v-else>
                        未完善
                    </div>
                </div>
            </div>
        </div>


        <div class="resume_info_box">
            <div class="card_title">
                当前项目
            </div>
            <div class="resume_info_field">
                <div class="resume_field">
                    项目名称：
                </div>
                <div class="resume_value">
                    {{ resume_info.project_name }}
                </div>
            </div>
        </div>



        <div class="affirm_add" @click="click_affirm_qr">
            <Icon type="md-add-circle" style="margin-right:5px" /> 确认录入
        </div>
        <div class="affirm_add2" @click="click_scan">
            <Icon type="md-qr-scanner" style="margin-right:5px" />
            返回扫码
        </div>


    </div>
</template>

<script>
import { http, open_new_page } from "@/utils/http.js";

export default {
    data() {
        return {
            resume_id: "",
            project_id: '',
            resume_info: {}
        }
    },
    mounted() {
        var query = this.$route.query
        this.resume_id = query.resume_id
        this.project_id = query.project_id
        console.log(query)
        this.get_resume_info()
    },
    methods: {

        click_scan() {
            this.$router.go(-1)
        },

        click_affirm_qr() {
            var that = this
            var obj = {
                resume_id: this.resume_id,
                project_id: this.project_id
            }
            http("post", process.env.VUE_APP_HOST + "/my_project/daimianshi/add_qr", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.$Message.success({
                            content: res.msg,
                            duration: 5,
                        });
                        that.$router.go(-1)

                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },

        //查看身份证照片
        view_idcard_img(url) {
            wx.previewImage({
                current: url, // 当前显示图片的 http 链接
                urls: [url] // 需要预览的图片 http 链接列表
            });

            // 上传图片接口
        },

        //获取简历详情
        get_resume_info() {
            var that = this
            var obj = {
                resume_id: this.resume_id,
                project_id: this.project_id
            }
            http("post", process.env.VUE_APP_HOST + "/my_project/daimianshi/resume_detail", obj, true).then(
                (res) => {
                    if (res.code == 0) {
                        that.resume_info = res.data.detail
                    } else {
                        that.$Message.error({
                            content: res.msg,
                            duration: 3,
                        });
                    }
                }
            ).catch((res) => {

                console.log(res, '请求出错')
            })
        },
    }
}
</script>

<style  scoped>
.affirm_add2 {
    background-color: #f3f3f3;
    color: #6986ab;
    padding: 13px 0;
    margin: 20px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    margin-top: 10px;
    border: 1px solid rgb(232, 232, 232)
}

.affirm_add {
    background-color: #0466dd;
    color: #fff;
    padding: 13px 0;
    margin: 20px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 4px;
    margin-top: 30px;
}

.idcard_img {
    border-radius: 5px;
    width: 170px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid rgb(243, 243, 243);
    color: #ccc;
}

.card_title {
    background-color: #e3e3e3;
    color: rgb(130, 130, 130);
    width: 80px;
    padding: 3px 0;
    border-radius: 5px 0 5px 0;
    text-align: center;
    font-size: 12px;
    margin-bottom: 10px;

}


.main {
    min-height: 100vh;
    overflow: auto;
    background-color: #f5f7f9;
}

.resume_info_box {
    background-color: #fff;
    box-shadow: 0 0 3px rgb(236, 236, 236);
    margin: 20px;
    border-radius: 5px;
    padding-bottom: 10px;

}

.resume_value {
    font-size: 13px;
    color: #333;
}

.resume_field {
    width: 80px;
    flex-shrink: 0;
    font-size: 13px;
}

.weishiming {
    color: rgb(235, 6, 6);
}

.resume_info_field {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
    padding: 0 10px;
}
</style>